import $ from 'jquery';
import 'slick-carousel';


const catOptions = {
   dots: false,
   infinite: true,
   mobileFirst: true,
   slidesToShow: 1,
   slidesToScroll: 1,
   prevArrow: '',
   nextArrow: '',
   responsive: [{
      breakpoint: 1200,
      settings: {
         slidesToShow: 4,
         slidesToScroll: 1,
         infinite: true
      }
   }]
}


$('.jsProdSlider').each(function (index) {
   $(this).slick(catOptions);
});

const brandsOptions = {
   dots: false,
   infinite: true,
   mobileFirst: true,
   slidesToShow: 2,
   autoplay: true,
   slidesToScroll: 1,
   prevArrow: '',
   nextArrow: '',
   responsive: [{
      breakpoint: 767,
      settings: {
         slidesToShow: 4,
         slidesToScroll: 1,
         infinite: true
      }},
      {
         breakpoint: 1200,
         settings: {
            slidesToShow: 8,
            slidesToScroll: 1,
            infinite: true
         }
      }
   ]
}

$("#brandsSlider").slick(brandsOptions);

if (window.innerWidth < 1200) {
   $('.jsMobSlider').each(function (index) {
      $(this).slick(mobOptions);
   });
}

$('#mainImage').slick({
   slidesToShow: 1,
   slidesToScroll: 1,  
   arrows: true,
   fade: true,
   prevArrow: '<div class="arrow arrow--prev"><svg><use xlink:href="#chevron-left-regular"></use></svg></div>',
   nextArrow: '<div class="arrow arrow--next"><svg><use xlink:href="#chevron-right-regular"></use></svg></div>', 
   asNavFor: '#imageNav'
});
$('#imageNav').slick({
   slidesToShow: 6,
   slidesToScroll: 1,
   asNavFor: '#mainImage',
   mobileFirst: true,
   arrows: false,
   dots: false,  
   focusOnSelect: true
  
});

const blogOptions = { 
   slidesToShow: 1,
   slidesToScroll: 1,  
   arrows: true, 
   infinite: true,
   mobileFirst: true,
   prevArrow: '<div class="arrow arrow--prev"><svg><use xlink:href="#chevron-left-regular"></use></svg></div>',
   nextArrow: '<div class="arrow arrow--next"><svg><use xlink:href="#chevron-right-regular"></use></svg></div>', 
   responsive: [
      {
        breakpoint: 500,
        settings: {       
          centerMode: true,
          centerPadding: '80px',         
        }
      }      
    ]
}

$('.jsBlogSlider').each(function (index) {
   $(this).slick(blogOptions);
});